import { TranscodingProfile } from "../media-transcoder/transcoding-profile";

export abstract class ICommonUtilInterface {
  abstract generateGuid(): string;
  abstract generateInteger(min: number, max: number): number;
  abstract generateText(length: number): string;
}
